package com.evoapps.evoshift.domain.staffimport

import com.evoapps.evoshift.domain.repository.UserRepository
import kotlinx.coroutines.async
import kotlinx.coroutines.awaitAll
import kotlinx.coroutines.coroutineScope

/** Who already works at the workplace, for the import's duplicate checks. */
data class TeamForImport(val names: List<String>, val emails: Set<String>)

/**
 * SH-214: the active team's names, and their e-mails when [withEmails] (they are private data:
 * only for those who may read it, Capability.MANAGE_PAY; others get no e-mail check against the
 * team). A person whose private data cannot be read simply has no e-mail here.
 */
class GetTeamForImportUseCase(private val users: UserRepository) {
    suspend operator fun invoke(workplaceId: String, withEmails: Boolean): Result<TeamForImport> = runCatching {
        val team = users.getAssignableEmployees(workplaceId).getOrThrow()
        val emails = if (!withEmails) emptySet() else coroutineScope {
            team.map { person -> async { users.getSensitiveUserData(person.uid).getOrNull()?.email } }.awaitAll()
        }.mapNotNullTo(HashSet()) { it?.trim()?.lowercase()?.takeIf(String::isNotEmpty) }
        TeamForImport(team.map { it.displayName }, emails)
    }
}
